// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3276-56737
// Component: PaymentReference
// States: normal | disabled (opacity-38) | required-error (red subtitle + pencil always shown)

import classnames from 'classnames'
import { Icon } from '~/components'

export default function PaymentReference({ title, value, disabled, required, empty, onEdit }) {
  const hasError = required && empty
  const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'

  return (
    <div className={classnames('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]')}>
      <div className="shrink-0 size-11 flex items-center justify-center">
        <img
          src={`/app/themes/${theme}/static/img/option-icons/Reference.png`}
          alt=""
          className="size-full object-contain"
        />
      </div>

      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{title}</span>
        {value && (
          <span className={classnames('text-[15px] leading-5', hasError ? 'text-[#cc2312]' : 'text-on-surface-variant')}>
            {value}
          </span>
        )}
      </div>

      {onEdit && !disabled && (
        <button
          type="button"
          onClick={onEdit}
          className="shrink-0 p-2 -mr-2"
          aria-label="Edit reference"
        >
          <Icon id="pen" />
        </button>
      )}
    </div>
  )
}
